import React, { useState, useEffect } from 'react';
import { IconButton, Paper, Tooltip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import WorkOffIcon from '@mui/icons-material/WorkOff'; // Updated icon for Leave Management
import AccessTimeIcon from '@mui/icons-material/AccessTime'; // Updated icon for Tasks Time Sheet
import ReceiptIcon from '@mui/icons-material/Receipt'; // Updated icon for Salary Slip

const FloatingVerticalMenu = ({ onMenuSelect, selectedMenu }) => {
  const [activeMenu, setActiveMenu] = useState(() => {
    return sessionStorage.getItem('selectedMenu') || selectedMenu || 'dashboard';
  });

  useEffect(() => {
    onMenuSelect(activeMenu);
  }, [activeMenu, onMenuSelect]);

  const handleMenuSelect = (menu) => {
    setActiveMenu(menu);
    sessionStorage.setItem('selectedMenu', menu);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        top: '49%',
        left: '16px',
        width: '60px',
        transform: 'translateY(-50%)',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        borderRadius: '16px',
      }}
    >
      <Tooltip
        title="Dashboard"
        enterDelay={200}
        leaveDelay={200}
        arrow
        placement="right"
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [10, 0],
              },
            },
          ],
        }}
      >
        <IconButton
          onClick={() => handleMenuSelect('dashboard')}
          sx={{
            color: activeMenu === 'dashboard' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <DashboardIcon />
        </IconButton>
      </Tooltip>

      <Tooltip
        title="Leave Management"
        enterDelay={200}
        leaveDelay={200}
        arrow
        placement="right"
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [10, 0],
              },
            },
          ],
        }}
      >
        <IconButton
          onClick={() => handleMenuSelect('leaveManagement')}
          sx={{
            color: activeMenu === 'leaveManagement' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <WorkOffIcon />
        </IconButton>
      </Tooltip>

      <Tooltip
        title="Tasks Time Sheet"
        enterDelay={200}
        leaveDelay={200}
        arrow
        placement="right"
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [10, 0],
              },
            },
          ],
        }}
      >
        <IconButton
          onClick={() => handleMenuSelect('tasks')}
          sx={{
            color: activeMenu === 'tasks' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <AccessTimeIcon />
        </IconButton>
      </Tooltip>

      <Tooltip
        title="Salary Slip"
        enterDelay={200}
        leaveDelay={200}
        arrow
        placement="right"
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [10, 0],
              },
            },
          ],
        }}
      >
        <IconButton
          onClick={() => handleMenuSelect('salary')}
          sx={{
            color: activeMenu === 'salary' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <ReceiptIcon />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default FloatingVerticalMenu;
